import { TransientSession } from './transient-session.ts'
import { SessionStore } from '../storage/session-storage-manager.ts'

export class SessionManager {
    public readonly transient: TransientSession

    constructor(sessionStore: SessionStore) {
        this.transient = new TransientSession(sessionStore)
    }

    public _start() {
        this.transient._start()
    }

    public _stop() {
        this.transient._stop()
    }
}
